import { render, staticRenderFns } from "./RuleSettings.vue?vue&type=template&id=ed04af14&scoped=true"
import script from "./RuleSettings.vue?vue&type=script&lang=js"
export * from "./RuleSettings.vue?vue&type=script&lang=js"
import style0 from "./RuleSettings.vue?vue&type=style&index=0&id=ed04af14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed04af14",
  null
  
)

export default component.exports